export default {
  title: 'Ativar tag',
  subtitle: 'Digite o serial e o código de ativação impressos na tag.',
  code_label: 'Código da tag',
  code_placeholder: 'Ex.: LZ-000000',
  secret_label: 'Código de ativação',
  secret_hint: 'Vem impresso junto da tag.',
  name_label: 'Nome da tag',
  name_placeholder: 'Ex.: Thor, Mochila, Chaveiro',
  category: 'Categoria',
  group_optional: 'Grupo (opcional)',
  none: 'Nenhum',
  submit: 'Ativar tag',
  done_title: 'Tag ativada',
  done_received: 'Localização recebida',
  done_received_body: 'Já recebemos a primeira detecção desta tag.',
  done_waiting_body: 'A localização aparecerá quando recebermos a primeira detecção.',
  view_on_map: 'Ver no mapa',
  scan_title: 'Aponte a câmera para o QR Code da sua tag',
  scan_hint: 'A câmera só é usada para ler o código.',
  camera_unavailable: 'Câmera indisponível — digite o código abaixo.',
  scan_qr: 'Escanear QR Code',
  stop_camera: 'Parar câmera',
  or_type: 'Ou digite o código',
  check_code: 'Confira se o código bate com o da sua tag.',
  view_my_tags: 'Ver minhas tags',
}
